import Typography from '@components/Typography';
import { Button } from '@components/Button';
import getLayerStore from '@stores/LayerStore';
import { GetInTouchWrapper } from './style';

import type React from 'react';

interface GetInTouchProps {
  title: string;
  name?: string;
  caption?: string;
  buttonText: string;
  avatarUrl?: string;
  className?: string;
}

const LayerStore = getLayerStore();

export const GetInTouch: React.FC<GetInTouchProps> = ({
  title,
  name,
  caption,
  buttonText,
  avatarUrl,
  className,
}) => {
  const handleClick = (): void => {
    LayerStore.setVisibilityWidgetX(true);
  };

  return (
    <GetInTouchWrapper className={className}>
      <div className="header">
        <Typography className="title" type="H3">
          {title}
        </Typography>
        {avatarUrl && <img className="avatar" src={avatarUrl} alt="avatar" />}
      </div>
      {name && (
        <Typography className="name" type="B2">
          {name}
        </Typography>
      )}
      {caption && (
        <Typography className="caption" type="B2">
          {caption}
        </Typography>
      )}
      <Button onClick={handleClick} className="CTA" primary large>
        {buttonText}
      </Button>
    </GetInTouchWrapper>
  );
};
